<template>
    <div class="container-fluid container-fixed-lg">
        <h1 v-if="!modal" class="section-title p-l-10">
            ORGANIZATION
        </h1>
        <div class="row">
            <div class="col-md-12">
                <organizations-form
                    v-if="isReady"
                    :organization="organization"
                    :modal="modal"
                    :mode="mode"
                    mode="standalone"
                    @cancel="cancel()"
                    @save="cancel()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import OrganizationsFormMixins from "./form-mixins";

export default {
    name: "OrganizationsResource",
    mixins: [OrganizationsFormMixins],
    props: {
        mode: {
            type: String,
            default: "none"
        },
        modal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isReady: false
        };
    },
    async created() {
        this.orgId = this.$route.params.id;

        if (this.orgId) {
            await this.fetchOrganization();
        } else {
            this.organization = {};
        }

        this.isReady = true;
    },
    methods: {
        cancel() {
            if (this.modal) {
                this.$modal.hide("Create-Organizations");
            } else {
                this.$router.push({
                    name: "browse",
                    params: {
                        resource: "organizations"
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss">
.organization-form {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    > div {
        flex: 1 50%;
        max-width: 49%;
    }

    > div:last-child {
        max-width: 100%;
    }

    .form-group {
        .col-3,
        .col-9 {
            flex: 1 100%;
            max-width: 100%;
        }

        .control-label {
            padding-left: 0;
        }
    }

    .row {
        margin-left: 0;
        margin-right: 0;
    }

    &--footer {
        .btn {
            border-radius: 5px;
            font-size: 14px;
            margin-top: 0;
            padding: 5px 20px;
        }
    }
}
</style>
